import gql from 'graphql-tag';

export const VERTICAL_LIST = gql` 
query organizationQueryVerticalList($id: ID!, $search: String) {
  organizationById(id: $id) {
    id
    verticalSet(name_Icontains: $search) {
      edges {
        node {
          id
          name
          parentvertical {
            id
          }
          heads {
            edges {
              node {
                id
              }
            }
          }
          teamSet {
            totalCount
          }
        }
      }
    }
  }
}
`;

export const TEAM_LIST = gql`
 query organizationQueryTeamList($vertical: Float, $search: String, $id: ID!) {
  organizationById(id: $id) {
    id
    verticalSet(id: $vertical) {
      edges {
        node {
          teamSet(name_Icontains: $search) {
            edges {
              node {
                id
                vertical {
                  id
                }
                managers {
                  edges {
                    node {
                      id
                    }
                  }
                }
                name
              }
            }
          }
        }
      }
    }
  }
}
`;

export const TEAM_LIST_VERTICAL_ID = gql`
query organizationQueryTeamListVerticalId ($id: ID!, $vertical: Float){
  organizationById(id: $id) {
    id
    verticalSet(id: $vertical) {
      edges {
        node {
          teamSet {
            edges {
              node {
                id
                name
                vertical {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const CREATE_VERTICAL = gql`
mutation organizationQueryCreateVertical($verticalData: VerticalInput!) {
  createVertical(verticalData: $verticalData) {
    vertical {
      id
    }
  }
}
`

export const CREATE_TEAM = gql`
mutation organizationQueryCreateTeam($teamData: TeamInput!) {
  createTeam(teamData: $teamData){
    team{
    id
    }
  }
}
`

export const VERTICAL_DETAIL_TREE = gql`
query organizationQueryVerticalDetailTree ($orgId: ID!, $verticalFloat: Float, $verticalString: ID, ,$after:String){
  organizationById(id: $orgId) {
    id
    verticalSet(id: $verticalFloat) {
      edges {
        node {
          id
          name
          heads {
            edges {
              node {
                id
                user {
                  id
                  email
                  firstName
                  lastName
                  profile {
                    id
                    profileImage
                  }
                }
              }
            }
          }
          employees(after: $after) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                memberSet(fromVertical: $verticalString, first: 1) {
                  edges {
                    node {
                      id
                    }
                  }
                }
                user {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const ORGANIZATION_EMPLOYEE = gql`
query organizationQueryOrganizationEmployee($user_FirstName: String, $id: ID!) {
  organizationById(id: $id) {
    id
    employees(name: $user_FirstName) {
      edges {
        node {
          id
          user {
            id
            email
            firstName
            lastName
            profile {
              id
              profileImage
            }
            employee {
              id
            }
          }
        }
      }
    }
  }
}
`;

export const VERTICAL_EMPLOYEE = gql`
query organizationQueryVerticalEmployee($id: ID!, $vertical: Float, $user_FirstName: String) {
  organizationById(id: $id) {
    id
    verticalSet(id: $vertical) {
      edges {
        node {
          id
          heads(user_FirstName: $user_FirstName) {
            edges {
              node {
                id
                user {
                  id
                  email
                  firstName
                  lastName
                  profile {
                    id
                    profileImage
                  }
                }
              }
            }
          }
          employees(name: $user_FirstName) {
            edges {
              node {
                id
                user {
                  id
                  email
                  firstName
                  lastName
                  profile {
                    id
                    profileImage
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const TEAM_DETAIL_TREE = gql`
  query organizationQueryTeamDetailTree($id: ID!,$after:String) {
    Team(id:$id) {
      id
      name
      managers{
        edges{
          node{
            id
            user{
              id
              email
              firstName
              lastName
              profile{
                id
                profileImage
              }
            }
          }
        }
      }
      employees(after:$after){
        pageInfo{
          hasNextPage
          endCursor
        }
        edges{
          node{
            id
            memberSet(fromTeam:$id,first:1) {
              edges {
                node {
                  id
                }
              }
            }
            user{
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;

export const ALL_EMPLOYEE_LIST_QUERY = gql`
query organizationQueryAllEmployeeListQuery($user_IsActive: Boolean, $search: String, $employee_verified_cursor: String, $employee_nonverified_cursor: String, $id: ID!) {
  organizationById(id: $id) {
    id
    verified: employees(user_Status_Verified: true, user_IsActive: $user_IsActive, first: 25, after: $employee_verified_cursor, name: $search) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          user {
            id
            firstName
            lastName
            email
            isActive
            profile {
              id
              activatedDate
              deactivatedDate
            }
          }
          orgPocEmployee {
            totalCount
          }
          orgCeoEmployee {
            totalCount
          }
          verticalHeadEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          verticalMembersEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          teamManagerEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          teamMembersEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
    nonverified: employees(user_Status_Verified: false, user_IsActive: $user_IsActive, first: 25, after: $employee_nonverified_cursor, name: $search) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          user {
            id
            firstName
            lastName
            email
            isActive
            profile {
              id
              activatedDate
              deactivatedDate
            }
          }
          orgPocEmployee {
            totalCount
          }
          orgCeoEmployee {
            totalCount
          }
          verticalHeadEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          verticalMembersEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          teamManagerEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          teamMembersEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
`

export const ALL_VERTICAL_EMPLOYEE_LIST_QUERY = gql`
query organizationQueryAllEmployeeVerticalListQuery($id_In: [String], $user_IsActive: Boolean, $search: String, $offset: Int, $id: ID!) {
  organizationById(id: $id) {
    id
    verticalSet(id_In: $id_In) {
      edges {
        node {
          id
          verified_heads: heads(offset: $offset, user_Status_Verified: true, user_IsActive: $user_IsActive, user_FirstName: $search, first: 25) {
            pageInfo {
              hasNextPage
            }
            edges {
              node {
                id
                user {
                  id
                  firstName
                  lastName
                  email
                  isActive
                  profile {
                    id
                    activatedDate
                    deactivatedDate
                  }
                }
                orgPocEmployee {
                  totalCount
                }
                orgCeoEmployee {
                  totalCount
                }
                verticalHeadEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                verticalMembersEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                teamManagerEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                teamMembersEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
          nonverified_heads: heads(offset: $offset, user_Status_Verified: false, user_IsActive: $user_IsActive, user_FirstName: $search, first: 25) {
            pageInfo {
              hasNextPage
            }
            edges {
              node {
                id
                user {
                  id
                  firstName
                  lastName
                  email
                  isActive
                  profile {
                    id
                    activatedDate
                    deactivatedDate
                  }
                }
                orgPocEmployee {
                  totalCount
                }
                orgCeoEmployee {
                  totalCount
                }
                verticalHeadEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                verticalMembersEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                teamManagerEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                teamMembersEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
          verified: employees(offset: $offset, user_Status_Verified: true, user_IsActive: $user_IsActive, name: $search, first: 10) {
            pageInfo {
              hasNextPage
            }
            edges {
              node {
                id
                user {
                  id
                  firstName
                  lastName
                  email
                  isActive
                  profile {
                    id
                    activatedDate
                    deactivatedDate
                  }
                }
                orgPocEmployee {
                  totalCount
                }
                orgCeoEmployee {
                  totalCount
                }
                verticalHeadEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                verticalMembersEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                teamManagerEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                teamMembersEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
          nonverified: employees(offset: $offset, user_Status_Verified: false, user_IsActive: $user_IsActive, name: $search, first: 10) {
            pageInfo {
              hasNextPage
            }
            edges {
              node {
                id
                user {
                  id
                  firstName
                  lastName
                  email
                  isActive
                  profile {
                    id
                    activatedDate
                    deactivatedDate
                  }
                }
                orgPocEmployee {
                  totalCount
                }
                orgCeoEmployee {
                  totalCount
                }
                verticalHeadEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                verticalMembersEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                teamManagerEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                teamMembersEmployee {
                  totalCount
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const ORG_POC_VERTICAL_GRAPH_DATA = gql`
query organizationQueryOrgPocVerticalGraphData($id: ID!, $survey_id: ID) {
  organizationById(id: $id) {
    id
    surveySet(id: $survey_id) {
      edges {
        node {
          id
          summaryListByVertical(organizationId: $id)
        }
      }
    }
  }
}
`

export const ORG_POC_TEAM_GRAPH_DATA = gql`
query organizationQueryOrgPocTeamGraphData($id: ID!$survey_id: ID,$vid: String!){
  organizationById(id:$id){
    id
    surveySet(id:$survey_id){
      edges{
        node{
          id
          summaryListByVerticalTeam(vid:$vid)
        }
      }
    }
  }
}
`

export const ALL_TEAM_EMPLOYEE_LIST_QUERY = gql`
query organizationAllTeamEmployeeListQuery($id_In: [String],$user_IsActive:Boolean,$search:String,$offset:Int){
    Teams(id_In: $id_In) {
    edges {
      node {
        id

        verified_managers: managers(offset:$offset,user_Status_Verified:true,user_IsActive:$user_IsActive,user_FirstName:$search,first:25) {
          
          pageInfo{
            hasNextPage
          }
          edges {
            node {
              id
              user {
                id
                firstName
                lastName
                email
                isActive
                profile{
                  id
                  activatedDate
                  deactivatedDate
                }
              }
              orgPocEmployee {
                totalCount
              }
              orgCeoEmployee {
                totalCount
              }
              verticalHeadEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              verticalMembersEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              teamManagerEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              teamMembersEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }

        nonverified_managers: managers(offset:$offset,user_Status_Verified:false,user_IsActive:$user_IsActive,user_FirstName:$search,first:25) {
          pageInfo{
            hasNextPage
            
          }
          edges {
            node {
              id
              user {
                id
                firstName
                lastName
                email
                isActive
                profile{
                  id
                  activatedDate
                  deactivatedDate
                }
              }
              orgPocEmployee {
                totalCount
              }
              orgCeoEmployee {
                totalCount
              }
              verticalHeadEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              verticalMembersEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              teamManagerEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              teamMembersEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }

        verified: employees(offset:$offset,user_Status_Verified:true,user_IsActive:$user_IsActive,name:$search,first:10) {
          pageInfo{
            hasNextPage
            
          }
          edges {
            node {
              id
              user {
                id
                firstName
                lastName
                email
                isActive
                profile{
                  id
                  activatedDate
                  deactivatedDate
                }
              }
              orgPocEmployee {
                totalCount
              }
              orgCeoEmployee {
                totalCount
              }
              verticalHeadEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              verticalMembersEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              teamManagerEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              teamMembersEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
        nonverified: employees(offset:$offset,user_Status_Verified:false,user_IsActive:$user_IsActive,name:$search,first:10) {
          pageInfo{
            hasNextPage
          }
          edges {
            node {
              id
              user {
                id
                firstName
                lastName
                email
                isActive
                profile{
                  id
                  activatedDate
                  deactivatedDate
                }
              }
              orgPocEmployee {
                totalCount
              }
              orgCeoEmployee {
                totalCount
              }
              verticalHeadEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              verticalMembersEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              teamManagerEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              teamMembersEmployee {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const UPDATE_POC_EMPLOYEE_MUTATION = gql`
  mutation updateEmployee($id: ID!, $email: String,$fname: String,$lname: String,$status: Boolean) {
    updateEmployee(id:$id, email:$email, fname:$fname, lname:$lname,status:$status){
      employee{
        id
      }
    }
  }
`

export const POC_EMPLOYEE_TOTAL_COUNT = gql`
query organizationQueryPocEmployeeTotalCount($id: ID!) {
  organizationById(id: $id) {
    id
    employees {
      totalCount
    }
  }
}
`

export const EMPLOYEE_BY_ID_DETAIL = gql`
query organizationByIdemployeeByIdDetail($id: ID!){
employeeById(id:$id){
    verticalHeadEmployee{
      edges{
        node{
          id
          name
          heads{
            edges{
              node{
                id
              }
            }
          }
        }
      }
    }
    teamManagerEmployee{
      edges{
        node{
          id
          managers{
            edges{
              node{
                id
              }
            }
          }
        }
      }
    }
    memberSet{
      edges{
        node{
          id
          fromOrganization{
            id
          }
        }
      }
    }
  }
}
`

export const EMPLOYEE_EXPORT_QUERY = gql`
query organizationQueryEmployeeExportquery($offset: Int, $id: ID!) {
  organizationById(id: $id) {
    id
    verified: employees(first: 100, offset: $offset, user_Status_Verified: true) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          user {
            id
            firstName
            lastName
            email
            isActive
            dateJoined
            profile {
              id
              activatedDate
              deactivatedDate
            }
          }
          orgPocEmployee {
            totalCount
          }
          orgCeoEmployee {
            totalCount
          }
          verticalHeadEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          verticalMembersEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          teamManagerEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          teamMembersEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
    nonverified: employees(first: 100, offset: $offset, user_Status_Verified: false) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          user {
            id
            firstName
            lastName
            email
            isActive
            dateJoined
            profile {
              id
              activatedDate
              deactivatedDate
            }
          }
          orgPocEmployee {
            totalCount
          }
          orgCeoEmployee {
            totalCount
          }
          verticalHeadEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          verticalMembersEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          teamManagerEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
          teamMembersEmployee {
            totalCount
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
`
